export default class BlockSlider {
	static init() {

		let blocks = document.querySelectorAll('.block-slider');

		blocks.forEach( (block) => {
			const swiper = block.querySelector('.swiper-main-slider');
			const navigation = block.querySelector('.swiper-navigation');
			new Swiper(swiper, {
				slidesPerView: "1",
				grabCursor: true,
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				navigation: {
					nextEl: '.navigation-next',
					prevEl: '.navigation-prev',
				}
			});
		});
	}
}
